export const isOfficialFramework = (mrn: string | undefined): boolean =>
  mrn?.split("/")[3] !== "spaces";
